const initialState = { customer: '', site:'' }

function reduceLogo(state = initialState, action) {
  let nextState
  switch (action.type) {
    case 'UPDATE_LOGO':
      nextState = {
        ...state,
        customer: action.customer,
        site: action.site
      }
      return nextState || state
  default:
    return state
  }
}

export default reduceLogo